import { Injectable } from '@angular/core';

import { QuickBetConfig } from '@frontend/sports/common/client-config-data-access';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { BetslipTrackingData } from '../../tracking/tracking.models';
import { selectTrackingDetails } from '../quick-bet.selectors';

export enum QuickBetTracking {
    Betting = 'betting',
    QuickBetSeparated = 'quick bet',
    QuickBet = 'quickbet',
    Load = 'load',
    QuickBetRedesigned = 'quick bet redesigned',
    Click = 'click',
    Clear = 'clear',
    Close = 'close',
    ViewInBetslip = 'view in betslip',
    Footer = 'footer-',
    DeleteAll = 'confirm delete all',
}

@Injectable()
export class QuickBetTrackingService {
    constructor(
        private trackingService: TrackingService,
        private config: QuickBetConfig,
    ) {}

    trackLoad(): void {
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: QuickBetTracking.Betting,
            [trackingConstants.COMPONENT_LABEL_EVENT]: QuickBetTracking.QuickBetSeparated,
            [trackingConstants.COMPONENT_ACTION_EVENT]: QuickBetTracking.Load,
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.config.isEnabled ? QuickBetTracking.QuickBetRedesigned : NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: this.config.isEnabled ? QuickBetTracking.QuickBetRedesigned : NOT_APPLICABLE,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }

    trackRemovePicksButtonClick(details: ReturnType<typeof selectTrackingDetails>): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: QuickBetTracking.QuickBet,
            [trackingConstants.COMPONENT_LABEL_EVENT]: QuickBetTracking.DeleteAll,
            [trackingConstants.COMPONENT_ACTION_EVENT]: QuickBetTracking.Click,
            [trackingConstants.COMPONENT_POSITION_EVENT]: details.mode,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: QuickBetTracking.QuickBetRedesigned,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: details.mode,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: details.pickCount,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }

    trackCloseButtonClick(details: ReturnType<typeof selectTrackingDetails>): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: QuickBetTracking.Betting,
            [trackingConstants.COMPONENT_LABEL_EVENT]: QuickBetTracking.QuickBet,
            [trackingConstants.COMPONENT_ACTION_EVENT]: QuickBetTracking.Close,
            [trackingConstants.COMPONENT_POSITION_EVENT]: QuickBetTracking.Footer + details.mode,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: QuickBetTracking.QuickBetRedesigned,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: QuickBetTracking.QuickBet,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: details.pickCount,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }

    trackViewInBetslip(details: ReturnType<typeof selectTrackingDetails>): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: QuickBetTracking.Betting,
            [trackingConstants.COMPONENT_LABEL_EVENT]: QuickBetTracking.QuickBet,
            [trackingConstants.COMPONENT_ACTION_EVENT]: QuickBetTracking.Click,
            [trackingConstants.COMPONENT_POSITION_EVENT]: QuickBetTracking.Footer + details.mode,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.config.isEnabled ? QuickBetTracking.QuickBetRedesigned : NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: QuickBetTracking.ViewInBetslip,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: details.pickCount,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }

    trackQuickBetClientErrors(trackingData: BetslipTrackingData, details: ReturnType<typeof selectTrackingDetails>): void {
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: QuickBetTracking.Betting,
            [trackingConstants.COMPONENT_LABEL_EVENT]: QuickBetTracking.QuickBet,
            [trackingConstants.COMPONENT_ACTION_EVENT]: QuickBetTracking.Load,
            [trackingConstants.COMPONENT_POSITION_EVENT]: trackingData.positionEvent,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: QuickBetTracking.QuickBetRedesigned,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: trackingData.eventDetails,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: details.pickCount,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }
}
